<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Submissions</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <span class="breadcrumb-item active">Submissions</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input v-model="searchQuery" class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..." />
                </div>
              </div>
              <div class="dataTables_length status_filter">
                <label>Show
                  <select v-model="statusFilter" @change="filterDatatable" aria-controls="DataTables_Table_0" class="">
                    <option value="all">All</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="declined">Declined</option>
                  </select>
                  submissions</label>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Artist Name</th>
                    <th>Twitter/IG Username</th>
                    <th>Spotify Url</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="submission in submissions" :key="submission.id">
                    <td>{{submission.id}}</td>
                    <td>{{submission.user_name}}</td>
                    <td>{{submission.user_email}}</td>
                    <td>{{submission.artist_name}}</td>
                    <td>{{submission.social_username}}</td>
                    <td>{{submission.spotify_url}}</td>
                    <td class="text-capitalize">{{submission.status}}</td>
                    <td>{{submission.submitted_at}}</td>
                    <td>
                      <i
                        class="fa fa-trash fa-icons"
                        @click="deleteSubmission(submission.id)"
                        aria-hidden="true">
                      </i>
                      <i
                        v-if="submission.status !== 'approved'"
                        class="fa fa-check fa-icons bg-green"
                        @click="updateSubmissionStatus(submission.id, 'approved')"
                        aria-hidden="true">
                      </i>
                      <i
                        v-if="submission.status !== 'declined'"
                        class="fa fa-times fa-icons bg-red"
                        @click="updateSubmissionStatus(submission.id, 'declined')"
                        aria-hidden="true">
                      </i>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Submission from '@/models/submission'
export default {
  name: 'Submissions',
  data () {
    return {
      datatable: null,
      searchQuery: '',
      statusFilter: 'all',
      submissions: []
    }
  },
  computed: {
    isLoading () {
      if (this.submissions.length === 0) {
        return this.$store.getters.apiStatus === 'loading'
      } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)

    let naturalScript = document.createElement('script')
    naturalScript.setAttribute('src', 'https://cdn.datatables.net/plug-ins/1.10.16/sorting/natural.js')
    document.head.appendChild(naturalScript)
    this.fetchAllSubmissions()
  },
  methods: {
    deleteSubmission (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this submission?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteSubmission', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllSubmissions()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    fetchAllSubmissions () {
      this.submissions = []
      this.$store.dispatch('fetchAllSubmissions')
        .then((result) => {
          result.data.submissions.forEach(submission => {
            this.submissions.push(new Submission(submission))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    updateSubmissionStatus (id, status) {
      this.$confirm({
        message: `Are you sure you want to update submission's status to "${status.toUpperCase()}"?`,
        button: {
          no: 'No',
          yes: 'Yes'
        },
        callback: confirm => {
          if (confirm) {
            this.$store.dispatch('updateSubmissionStatus', {
              id,
              status
            })
              .then((result) => {
                this.$toast.success(result.data.message)
                this.fetchAllSubmissions()
              })
              .catch((err) => this.$toast.error(err.response.data.message))
          }
        }
      })
    },
    searchDatatable (e) {
      this.datatable.search(this.searchQuery).column(5).search(this.statusFilter).draw()
    },
    filterDatatable (e) {
      if (this.statusFilter === 'all') {
        this.datatable.search(this.searchQuery).column(5).search('').draw()
        return
      }
      this.datatable.search(this.searchQuery).column(5).search(this.statusFilter).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        pagingType: 'full_numbers',
        'order': [
          [0, 'desc']
        ],
        columnDefs: [{
          targets: 4,
          'orderable': false
        }],
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html(
            "<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}

</script>

<style scoped>
  .bg-green {
    background: green
  }

  .bg-red {
    background: red;
    padding: 13px 15.19px
  }

  .status_filter {
    position: absolute;
    right: 12.5rem;
    top: 6.5rem;
    z-index: 9;
  }

  .status_filter select {
    border: 1px solid #ca3b2b;
    border-radius: 10px;
    background-color: #fff;
    padding: 3px 5px;
    outline: none;
  }

</style>



// WEBPACK FOOTER //
// src/views/Submission/Submissions.vue